export const getIsReadyToNarrate = (state) => state.isReadyToNarrate;

export const getIsPaused = (state) => state.isPaused;

export const getCaption = (state) => state.caption;

